import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f112d0ac&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=f112d0ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f112d0ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f112d0ac')) {
      api.createRecord('f112d0ac', component.options)
    } else {
      api.reload('f112d0ac', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=f112d0ac&scoped=true&", function () {
      api.rerender('f112d0ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/request_transaction/Index.vue"
export default component.exports